// Mirrored from cobu-universal to keep event names consistent across platforms
export enum AnalyticsEvent {
  APP_LAUNCHED = 'app_launched',
  APP_BACKGROUNDED = 'app_backgrounded',
  APP_FOREGROUNDED = 'app_foregrounded',
  ERROR_BOUNDARY_SHOWN = 'error_boundary_shown',
  LOGIN_ATTEMPT = 'login_attempt',
  LOGIN_SUCCESS = 'login_success',
  LOGIN_FAILURE = 'login_failure',
  LOGOUT = 'logout',
  SIGNUP_ATTEMPT = 'signup_attempt',
  SIGNUP_SUCCESS = 'signup_success',
  SIGNUP_FAILURE = 'signup_failure',
  SEND_OTP_ATTEMPT = 'send_otp_attempt',
  SEND_OTP_SUCCESS = 'send_otp_success',
  SEND_OTP_FAILURE = 'send_otp_failure',
  VERIFY_OTP_ATTEMPT = 'verify_otp_attempt',
  VERIFY_OTP_SUCCESS = 'verify_otp_success',
  VERIFY_OTP_FAILURE = 'verify_otp_failure',
  LANDING_LOGIN_BUTTON_PRESSED = 'landing_login_button_pressed',
  LANDING_SIGNUP_BUTTON_PRESSED = 'landing_signup_button_pressed',
  PASSWORD_RESET_ATTEMPT = 'password_reset_attempt',
  PASSWORD_RESET_SUCCESS = 'password_reset_success',
  PASSWORD_RESET_FAILURE = 'password_reset_failure',
  VIEW_PROFILE = 'view_profile',
  EDIT_PROFILE = 'edit_profile',
  DELETE_PROFILE = 'delete_profile',
  USER_UPDATE_PREVIOUS_VALUES = 'user_update_previous_values',
  USER_UPDATE_NEW_VALUES = 'user_update_new_values',
  UPDATE_USER_ATTEMPT = 'update_user_attempt',
  UPDATE_USER_SUCCESS = 'update_user_success',
  UPDATE_USER_FAILURE = 'update_user_failure',
  CHANGE_PASSWORD_ATTEMPT = 'change_password_attempt',
  CHANGE_PASSWORD_SUCCESS = 'change_password_success',
  CHANGE_PASSWORD_FAILURE = 'change_password_failure',
  DELETE_ACCOUNT_ATTEMPT = 'delete_account_attempt',
  DELETE_ACCOUNT_SUCCESS = 'delete_account_success',
  DELETE_ACCOUNT_FAILURE = 'delete_account_failure',
  VIEW_GROUPS = 'view_group_feed',
  VIEW_GROUP_DETAILS = 'view_group_details',
  JOIN_GROUP = 'join_group',
  LEAVE_GROUP = 'leave_group',
  SUGGEST_GROUP = 'suggest_a_group',
  USER_PROPOSE_GROUP = 'user_propose_group',
  SEND_MESSAGE_ATTEMPT = 'send_message_attempt',
  SEND_MESSAGE_SUCCESS = 'send_message_success',
  SEND_MESSAGE_FAILURE = 'send_message_failure',
  OPEN_DEEPLINK = 'open_deeplink',
  OPEN_DEEPLINK_FAILURE = 'open_deeplink_failure',
  BUILDING_TOOLTIP_LOADED = 'building_tooltip_loaded',
  BUILDING_TOOLTIP_LOAD_FAILED = 'building_tooltip_load_failed',
  BUILDING_TOOLTIP_CTA_PRESSED = 'building_tooltip_cta_pressed',
  BUILDING_TOOLTIP_CTA_FAILED = 'building_tooltip_cta_failed',
  BUILDING_TILES_LOADED = 'building_tiles_loaded',
  BUILDING_TILES_LOAD_FAILED = 'building_tiles_load_failed',
  NOTIFICATION_CENTER_OPENED = 'notification_center_opened',
  NOTIFICATION_CENTER_REFRESHED = 'notification_center_refreshed',
  NOTIFICATION_CENTER_LOAD_MORE = 'notification_center_load_more',
  NOTIFICATION_MARK_ALL_READ = 'notification_mark_all_read',
  NOTIFICATION_MARK_READ = 'notification_mark_read',
  NOTIFICATION_PRESSED = 'notification_pressed',
  NOTIFICATION_SETTINGS_OPENED = 'notification_settings_opened',
  NOTIFICATION_RECEIVED = 'notification_received',
  NOTIFICATION_CLICKED = 'notification_clicked',
  NOTIFICATION_DEEP_LINK = 'notification_deep_link',
  NOTIFICATION_PERMISSION_REQUESTED = 'notification_permission_requested',
  ALLOW_NOTIFICATIONS_BUTTON = 'allow_notifications_button',
  UNIVERSAL_BUTTON_FETCH_ATTEMPT = 'universal_button_fetch_attempt',
  UNIVERSAL_BUTTON_FETCH_SUCCESS = 'universal_button_fetch_success',
  UNIVERSAL_BUTTON_FETCH_FAILURE = 'universal_button_fetch_failure',
  UNIVERSAL_BUTTON_CLICK = 'universal_btn_click',
  INTRODUCTION_COMPLETED = 'introduction_completed',
  INTRODUCTION_COMPLETED_WITH_PHOTO = 'introduction_completed_with_photo',
  INTRODUCTION_COMPLETED_WITH_TEXT = 'introduction_completed_with_text',
  INTRODUCTION_SKIPPED = 'introduction_skipped',
  DID_COMPLETE_INTRODUCTION_POST = 'did_complete_introduction_post',
  DID_SKIP_INTRODUCTION_POST = 'did_skip_introduction_post',
  VIEW_GROUP_DISCUSSION = 'view_group_discussion',
  VIEW_CHAT = 'view_chat',
  CREATE_GROUP_COMMENT = 'create_group_comment',
  CREATE_CHAT_COMMENT = 'create_chat_comment',
  DELETE_COMMENT = 'delete_comment',
  EDIT_COMMENT = 'edit_comment',
  DID_ADD_REACTION = 'did_add_reaction',
  DID_REMOVE_REACTION = 'did_remove_reaction',
  DID_VIEW_REACTIONS = 'did_view_reactions',
  CREATE_REPLY = 'create_reply',
  EXPAND_REPLIES = 'expand_replies',
  REPORT_COMMENT = 'report_comment',
  PIN_COMMENT = 'pin_comment',
  UNPIN_COMMENT = 'unpin_comment',
  VIEW_USER_PROFILE = 'view_user_profile',
  BLOCK_USER = 'block_user',
  VIEW_ALL_MEMBERS = 'view_all_members',
  COMPOSE_COMMENT_STARTED = 'compose_comment_started',
  VIEW_DM_LIST = 'view_dm_list',
  VIEW_DM_CHANNEL = 'press_compose_dm_icon',
  COMPOSE_DM = 'compose_dm',
  SEND_DM = 'send_dm',
  BLOCK_DM_USER = 'block_dm_user',
  UNBLOCK_DM_USER = 'unblock_dm_user',
  DEACTIVATED_USER_SCREEN_VIEWED = 'deactivated_user_screen_viewed',
  DEACTIVATED_USER_CONTACT_SUPPORT_PRESSED = 'deactivated_user_contact_support_pressed',
  REFERRAL_HOME_CTA_CLICK = 'referral_home_cta_click',
  EVENT_FEED_VIEWED = 'event_feed_viewed',
  EVENT_FEED_REFRESHED = 'event_feed_refreshed',
  EVENT_FEED_FILTER_SELECTED = 'event_feed_filter_selected',
  ADD_EVENT_TO_CALENDAR = 'add_event_to_calendar',
  ALLOW_ACCESS_TO_CALENDAR = 'allow_access_to_calendar',
  USER_REPORTED_SUCCESSFULLY = 'user_reported_successfully',
  USER_REPORT_FAILED = 'user_report_failed',
  EVENT_FEEDBACK_DIALOG_SHOWN = 'event_feedback_dialog_shown',
  EVENT_FEEDBACK_RATING_SELECTED = 'event_feedback_rating_selected',
  EVENT_FEEDBACK_SUBMITTED = 'event_feedback_submitted',
  EVENT_FEEDBACK_SUBMISSION_FAILED = 'event_feedback_submission_failed',
  EVENT_DID_NOT_ATTEND = 'event_did_not_attend',
  GOOGLE_REVIEW_DIALOG_SHOWN = 'google_review_dialog_shown',
  GOOGLE_REVIEW_SKIPPED = 'google_review_skipped',
  GOOGLE_REVIEW_TIMESTAMP_UPDATED = 'google_review_timestamp_updated',
  GOOGLE_REVIEW_TIMESTAMP_UPDATE_FAILED = 'google_review_timestamp_update_failed',
  GOOGLE_REVIEW_CLICKED = 'google_review_clicked',
  SHOW_GOOGLE_REVIEW_MODAL = 'show_google_review_modal',
  BRANCH_DEEPLINK_OPEN = 'branch_deeplink_open',
  BRANCH_DEEPLINK_OPEN_FAILURE = 'branch_deeplink_open_failure',
  CREATE_COMMENT = 'comment_created',
  CREATE_COMMENT_FAILURE = 'create_comment_failure',
  PRESS_COMPOSE_DM_ICON = 'press_componse_dm_icon',
  BLOCKED_PROFANITY = 'blocked_profanity',
  PRESS_COMMENT_IMAGE_UPLOAD_BUTTON = 'press_comment_image_upload_button',
  COMPLETE_FEEDBACK = 'complete_feedback',
  VIEW_GROUP_EVENT_DETAILS = 'view_group_event_details',
  VIEW_GROUP_EVENT_DETAIL = 'view_group_event_detail',
  CREATE_GROUP_EVENT = 'create_group_event',
  RSVPED_TO_GATHERING = 'rsvped_to_gathering',
  DELETE_RSVP = 'delete_rsvp',
  VIEW_EVENT_DETAIL = 'view_event_detail',
  OPEN_RSVP_MODAL = 'open_rsvp_modal',
  CLOSE_RSVP_MODAL = 'close_rsvp_modal',
  VIEW_WHOS_COMING_TO_EVENT = 'view_whos_coming_to_event',
  VIEW_EVENT_FEED = 'view_event_feed',
  REFRESH_EVENT_FEED = 'refresh_event_feed',
  SELECT_EVENT_FILTER = 'select_event_filter',
  PRESS_NOTIFICATION_BELL = 'press_notification_bell',
  VIEW_PERKS_TAB = 'view_perks_tab',
  SELECT_PERK_FILTER = 'select_perk_filter',
  SEARCH_PERK_FEED = 'search_perk_feed',
  PERK_SAVED = 'perk_saved',
  PERK_UNSAVED = 'perk_unsaved',
  VIEW_PERK_DETAIL = 'view_perk_detail',
  REDEEM_PERK_CLICK = 'redeem_perk_click',
  REFERRAL_DETAILS_MOUNTED = 'referral_details_mounted',
  REFERRAL_REFER_NOW = 'referral_refer_now',
  REFERRAL_SHARE = 'referral_share',
  VIEW_PROFILE_PAGE = 'view_profile_page',
  UPDATE_PROFILE_INFO = 'update_profile_info',
  PRESS_IMAGE_UPLOAD_BUTTON = 'press_image_upload_button',
  OPEN_MANAGE_PUBLIC_PROFILE = 'open_manage_public_profile',
  VIEW_PUBLIC_PROFILE = 'view_public_profile',
  PRESS_EDIT_PROFILE_PICTURE = 'press_edit_profile_picture',
  UPDATE_PROFILE_IMAGE = 'update_profile_image',
  REPORT_DM_USER = 'report_dm_user',
  VIEW_CONFIRM_NUMBER_PAGE = 'view_confirm_number_page',
  PRESS_RESEND_CODE = 'press_resend_code',
  PRESS_CONFIRM_NUMBER = 'press_confirm_number',
  CANCEL_UPDATE_PHONE = 'cancel_update_phone',
  UPDATE_PHONE_NUMBER = 'update_phone_number',
  VIEW_NOTIFICATION_CENTER = 'view_notification_center',
  HOME_TAB_VIEWED = 'home_tab_viewed',
  HOME_TILE_CLICK = 'home_tile_click',
  ENABLE_PUSH_NOTIFICATIONS = 'enable_push_notifications',
  DISABLE_PUSH_NOTIFICATIONS = 'disable_push_notifications',
  DEEPLINK_CLICK = 'deeplink_click',
  DID_COMPLETE_PLEDGE = 'did_complete_pledge',
  DID_OPEN_CODE_OF_CONDUCT = 'did_open_code_of_conduct',
  CREATE_GATHERING_COMMENT = 'create_gathering_comment',
  REQUEST_PASSWORD_RESET = 'request_password_reset',
  USER_AUTHORIZED = 'user_authorized',
}


